// Dark mode floating toggle button.
// Originally ported from bishopric-complete/index.html:278-297.
//
// M3 updates:
//  - Also sets/unsets `data-theme="dark"` on <html> so design-system
//    tokens.css dark-mode selectors activate alongside the legacy
//    `body.dark-mode` class.
//  - Replaces 🌙 / ☀️ emoji with Ionicons (moon-outline / sunny-outline)
//    per design-system "no emoji in product UI" rule. Ionicons is loaded
//    via the CDN <script> in index.html.

function applyTheme(isDark: boolean): void {
  document.body.classList.toggle('dark-mode', isDark)
  document.documentElement.dataset.theme = isDark ? 'dark' : 'light'
}

function iconFor(isDark: boolean): string {
  // Icon shown is the mode you'll switch TO when clicked.
  // Dark is active → show sun (click to go light). Light is active → show moon.
  const name = isDark ? 'sunny-outline' : 'moon-outline'
  return `<ion-icon name="${name}" style="font-size: 20px; color: var(--fg-2);"></ion-icon>`
}

function initDarkMode(): void {
  const btn = document.createElement('button')
  btn.className = 'dark-mode-toggle no-print'
  btn.title = 'Toggle dark mode'
  btn.onclick = () => {
    const nextDark = !document.body.classList.contains('dark-mode')
    applyTheme(nextDark)
    btn.innerHTML = iconFor(nextDark)
    localStorage.setItem('darkMode', nextDark ? '1' : '0')
  }
  document.body.appendChild(btn)

  const savedDark = localStorage.getItem('darkMode') === '1'
  applyTheme(savedDark)
  btn.innerHTML = iconFor(savedDark)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDarkMode)
} else {
  initDarkMode()
}
